import React from "react";
import Navbar from "../../component/Navbar";
import ChemicalComp from "../../component/solutionscomponent/ChemicalComp";
import Footer from "../../component/Footer";

const Chemical = () => {
  return <>
        <section className="usp_service_section">
        <Navbar />
        <ChemicalComp />
        <Footer />
      </section>
  </>;
};

export default Chemical;
